import React from "react";
import {
  getHonoreePresets,
  resetHonoreePresets,
} from "../../services/funds.service";
import { useController } from "react-hook-form";

const DonationOptions = ({ options, control, name }) => {
  const { field } = useController({
    control,
    name,
  });
  let honoreePresets = getHonoreePresets();
  const [value, setValue] = React.useState(field.value || null);

  const checkMemory = () =>
    honoreePresets && honoreePresets.type === "memory"
      ? true
      : (!honoreePresets ||
          (honoreePresets.type !== "" && honoreePresets.type !== "honor")) &&
        value === "memory";

  const checkHonor = () =>
    honoreePresets && honoreePresets.type === "honor"
      ? true
      : (!honoreePresets ||
          (honoreePresets.type !== "" && honoreePresets.type !== "memory")) &&
        value === "honor";

  return (
    <>
      {(!honoreePresets || (honoreePresets && !honoreePresets.hide)) &&
        options.map((option, index) => (
          <div key={index} className="form-switch">
            <label htmlFor={`in-${option}`}>
              <input
                onChange={(e) => {
                  resetHonoreePresets();
                  const newValue = e.target.checked ? e.target.value : null;
                  // send data to react hook form.
                  field.onChange(newValue);
                  setValue(newValue);
                }}
                key={option}
                type="checkbox"
                checked={option === "memory" ? checkMemory() : checkHonor()}
                value={option}
              />
              {`In ${option.charAt(0).toUpperCase() + option.slice(1)}`}
            </label>
          </div>
        ))}
    </>
  );
};

export default DonationOptions;
